import { render, staticRenderFns } from "./QuickEdges.vue?vue&type=template&id=9998b314&scoped=true"
import script from "./QuickEdges.vue?vue&type=script&lang=js"
export * from "./QuickEdges.vue?vue&type=script&lang=js"
import style0 from "./QuickEdges.vue?vue&type=style&index=0&id=9998b314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9998b314",
  null
  
)

export default component.exports